import { FC } from 'react';
import { AddressForm } from '@rich-products-corp/react-ecomm-ui/dist/components/PageSections/Ecommerce/forms/address';
import { useGoogleAutocomplete } from '@/hooks/useGoogleAutocomplete';

interface SingleShippingAddressFormProps {
  form: any;
  provinces: any[];
}

export const SingleShippingAddressForm: FC<SingleShippingAddressFormProps> = ({ form, provinces }) => {

  // Google Address Autocomplete.
  useGoogleAutocomplete({
    selector: 'input[name="shipping.streetAddress"]',
    form,
  });

  return (
    <>
      <AddressForm form={form} title="" schemaKey="shipping" states={provinces} />
      <div className="mt-5"></div>
    </>
  );
};
